import { request } from '@/utils/request'

// export interface ApiDictData {
//   dictLabel: string
//   dictValue: string
//   dictCode: string
//   dictSort: string
// }

export function loadDictData(dictType: string): Promise<ApiDictData[]> {
  return request.get('/common/dict?typeKey=' + dictType).then((res) => {
    return res.data as ApiDictData[]
  })
}

export const convertDictSelectData = (datas: ApiDictData[]) => {
  if (datas && datas.length > 0) {
    return datas.map(
      (m) =>
        <DictSelectData>{
          value: m.dictValue,
          text: m.dictLabel,
          dictCode: m.dictCode,
          dictSort: m.dictSort
        }
    )
  }
  return []
}

export function exchangeLoginInfo(): Promise<any> {
  return request
    .get<any>('/sysUser/exchangeLoginInfo')
    .then((res) => {
      // console.log('exchangeLoginInfo', res.data)
      return res.data
    })
    .catch((e) => {
      console.error(e)
      return {}
    })
}
